import React, { useState, useEffect } from "react";
import "../css/dashboard.css";
import { apiCall } from "../services/authServieces";

// Import icons from your assets folder
import Total from "../Assets/images/total.png";
import Delivered from "../Assets/images/delivered.png";
import Failed from "../Assets/images/failed.png";
import Read from "../Assets/images/read.png";
import smsIcon from "../Assets/images/sms.png";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    todayCount: 0,
    weekCount: 0,
    fifteenDaysCount: 0,
    monthCount: 0,
    isLoading: true
  });

  const fetchData = async () => {
    try {
      const res = await apiCall({
        endpoint: 'user/get_dashboard_data_user',
        method: 'GET',
        payload: ''
      });

      setDashboardData({
        todayCount: res.data.today_video_send_count,
        weekCount: res.data.week_video_send_count,
        fifteenDaysCount: res.data.last_15_days_video_send_count,
        monthCount: res.data.month_video_send_count,
        isLoading: false
      });
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setDashboardData(prev => ({ ...prev, isLoading: false }));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="Dashboard_contain">
        <h4 className="Head_title">
          <img src={smsIcon} alt="icon" className="Width20"/> WhatsApp Dashboard
        </h4>

        <div className="Dashboard_card">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className="whatsapp-card today-card">
                <div className="whatsapp-card-inner">
                  <div className="whatsapp-card-icon">
                    <img src={Total} alt="Today" />
                  </div>
                  <div className="whatsapp-card-content">
                    <h3 className="whatsapp-card-title">WhatsApp Messages Today</h3>
                    <p className="whatsapp-card-value">{dashboardData.todayCount}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className="whatsapp-card week-card">
                <div className="whatsapp-card-inner">
                  <div className="whatsapp-card-icon">
                    <img src={Delivered} alt="Week" />
                  </div>
                  <div className="whatsapp-card-content">
                    <h3 className="whatsapp-card-title">Messages This Week</h3>
                    <p className="whatsapp-card-value">{dashboardData.weekCount}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className="whatsapp-card fifteen-card">
                <div className="whatsapp-card-inner">
                  <div className="whatsapp-card-icon">
                    <img src={Failed} alt="15 Days" />
                  </div>
                  <div className="whatsapp-card-content">
                    <h3 className="whatsapp-card-title">Messages Last 15 Days</h3>
                    <p className="whatsapp-card-value">{dashboardData.fifteenDaysCount}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
              <div className="whatsapp-card month-card">
                <div className="whatsapp-card-inner">
                  <div className="whatsapp-card-icon">
                    <img src={Read} alt="Month" />
                  </div>
                  <div className="whatsapp-card-content">
                    <h3 className="whatsapp-card-title">Messages This Month</h3>
                    <p className="whatsapp-card-value">{dashboardData.monthCount}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;